module.exports = __webpack_public_path__ + "static/img/4.725c755.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/4.jpg
// module id = vTYS
// module chunks = 1